import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { useTeamworkingAnalytics } from "./teamworking_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./teamworking_partner_config";

const Theme = lazyWithRetry(() => import("./teamworking_theme"));

const faqs = [
  {
    question: "Do you have a kitchen?",
    answer:
      "Yes! We also have 3 lounges fully stocked with Dark Matter coffee, Coca-Cola and local beer on tap.",
  },
  {
    question: "Can I have access to the roof terrace?",
    answer: "Absolutely - work from our roof terrace with secured wifi.",
  },
  {
    question: "What's included with my day pass?",
    answer:
      "Enjoy space for a day in one of our 3 lounge areas with access to the rooftop terrace. Book space in one of our 12 huddle rooms if you need meeting space or quiet time.",
  },
];

export function OfferingTeamworkingDayPass() {
  useTeamworkingAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: `Work for the day in a place that has been built with today's team in mind - collaborative, flexible and hybrid.`,
          testimonials: testimonials,
          faqs: faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
